import { createNaturalMultiplicationTask, randInt, powerOfTenMultipleExplanation } from "./sharedNaturalMultiplication";

function pickData() {
  const a = randInt(12, 49);
  const place = [100, 1000, 10000][randInt(0, 2)];
  const compactFactor = randInt(2, 9);
  const b = compactFactor * place;
  return { a, b, place, result: a * b };
}

const mod = createNaturalMultiplicationTask({
  type: "NaturalMulTwoDigitByPowerOfTenMultipleTask",
  pickData,
  explain: powerOfTenMultipleExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
